module.exports = __webpack_public_path__ + "img/features_img_pembelian.8835dc4c.png";